<template>
  <div class="mod-show-table">
    <el-table
      ref="table"
      :data="listData.list"
      :show-header="!!headerShow"
      row-key="id"
      style="width: 100%"
      :header-row-style="_getHeaderRowStyle"
      header-cell-class-name="table-header-cell"
      @expand-change="expandChange"
      @selection-change="selectionChange"
    >
      <template v-for="column in listData.head">
        <el-table-column 
          v-if="column.type === 'index' || column.type === 'selection'"
          :key="column.key"
          :type="column.type"
        /> 
       <el-table-column
          v-else
          :key="column.key"
          :prop="column.key"
          :label="column.name"
          :type="column.type"
          :align="column.align"
          :width="_getActionWidth(column)"
        >
          <template slot-scope="scope">
            <TableColumn 
              :column="column" 
              :scope="scope"
              @handleClick="handleClick"
            />
          </template>
        </el-table-column>
      </template>
    </el-table>
    <div 
      v-if="pageShow" 
      class="page-footer-box"
    >
      <el-pagination
        :current-page="listData.currentPage"
        :page-sizes="pageSizes"
        :page-size="pageSize"
        :layout="layout.join(', ')"
        :total="listData.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import TableColumn from './modules/TableColumn';

export default {
  name: 'ShowTable',
  components: { TableColumn },
  props: {
    listData: {
      default: () => {
        return {
          head: [],
          list: [],
          currentPage: 1,
          total: 0,
        };
      },
    },
    rowKey: {
      default: '',
    },
    headerShow: {
      default: true,
    },
    pageShow: {
      default: true,
    },
    pageSize: {
      default: 10,
    },
    pageSizes: {
      default: () => {
        return [10, 20, 30];
      },
    },
    layout: {
      default: () => {
        return ['total', 'sizes', 'prev', 'pager', 'next', 'jumper'];
      },
    },
  },
  methods: {
    _getActionWidth(col) {
      if (col.width) return col.width;
      if (col.type === 'action') {
        let width = (col.actionList || []).length * 70;
        if (width < 90) {
          return '90px';
        }
        return `${width}px`;
      }
      return '';
    },
    _getHeaderRowStyle() {
      return {
        backgroudColor: "#FAFAFA"
      }
    },
    toggleRowExpansion(index, isExpand) {
      let row = index;
      if (typeof index === 'number') {
        row = this.listData.list[index];
      }
      this.$refs.table.toggleRowExpansion(row, isExpand);
    },
    handleClick() {
      this.$emit(...arguments);
    },
    handleSizeChange(size) {
      this.$emit('pageSizeChange', size);
    },
    handleCurrentChange(page) {
      this.$emit('pageChange', page);
    },
    expandChange() {
      // console.log(...arguments);
    },
    selectionChange() {
      this.$emit('selectionChange', ...arguments);
    },
  },
};
</script>

<style lang="scss">
.mod-show-table {
  .table-header-row {
    box-shadow: inset 0px -1px 0px 0px #CACED4;
  }
  .table-header-cell {
    background-color: #FAFAFA !important;
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #303133;
    line-height: 14px;
    .cell {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #303133;
      line-height: 14px;
    }
  }
  .page-footer-box {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 17px;
    .el-pagination__total {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #909399;
    }
    .btn-prev,
    .btn-next {
      display: inline-block;
      padding: 0;
      width: 30px;
      height: 28px;
      background: rgba(255, 255, 255, 0);
      border-radius: 4px;
      border: 1px solid #CACED4;
    }
    .btn-prev {
      margin-right: 17px;
    }
    .el-pager {
      .number {
        margin-right: 10px;
        width: 30px;
        height: 28px;
        min-width: none;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #303133;
        &:last-child {
          &.active {
            margin-right: 17px;
          }
        }
        &.active {
          background: #4F90FF;
          border-radius: 4px;
          color: #FFFFFF;
        }
      }
    }
  }
}
</style>